module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-500italic.f3d41e4c.woff";